import { comments } from '@/mocks/homeData';

export default function CommentSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-primary-500"></span>
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest">
              网友热评
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            吃瓜群众怎么说
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            来自真实用户的热门评论，看看大家对最新爆料的看法
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <h4 className="text-base font-bold text-foreground-950 mb-3">
                {comment.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.user}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{comment.user}</p>
                  <p className="text-xs text-foreground-500">{comment.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}